import { Link } from "react-router-dom";
import { Gauge, CalendarDays, Fuel, Settings2, Camera, Zap, Truck, Bike } from "lucide-react";
import { prefillAuto, scrollToId } from "@/lib/smooth";

const eur = (n) => new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);
export const km = (n) => (n ? `${new Intl.NumberFormat("it-IT").format(n)} km` : "n.d.");
export const cvDi = (a) => a.cv ?? a.cv_stimati ?? null;
const TIPO_BADGE = { commerciale: { label: "Veicolo commerciale", Icon: Truck }, moto: { label: "Scooter / moto", Icon: Bike } };

/** Dalla card: precompila il form di contatto della pagina con l'auto e ci scorre sopra (senza aprire la scheda). */
const contatta = (e, auto) => {
  e.preventDefault();
  e.stopPropagation();
  prefillAuto(`USATO: ${auto.versione} (${auto.anno || "n.d."}, ${km(auto.km)}, targa ${auto.targa || "n.d."})`);
  scrollToId("preventivo");
};

export const UsatoCard = ({ auto }) => (
  <Link
    to={`/usato/${auto.slug}/`}
    data-testid={`usato-card-${auto.slug}`}
    className="group flex h-full flex-col overflow-hidden rounded-2xl border border-xmove-ink/8 bg-white shadow-soft transition-all duration-300 hover:-translate-y-1 hover:shadow-lift"
  >
    <div className="relative aspect-[16/10] overflow-hidden bg-xmove-night">
      {auto.foto ? (
        <img src={auto.foto} alt={`${auto.marca} ${auto.modello}`} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]" data-testid="usato-card-foto" />
      ) : (
        <div className="flex h-full w-full flex-col items-center justify-center gap-2 px-6 text-center">
          <span className="font-display text-2xl font-bold uppercase tracking-tight text-white/90">{auto.marca}</span>
          <span className="text-sm font-semibold uppercase tracking-widest text-xmove-orange">{auto.modello}</span>
          {auto.link_foto && (
            <span className="mt-2 flex items-center gap-1.5 rounded-full bg-white/10 px-3 py-1 text-[11px] font-semibold text-white/80">
              <Camera size={12} /> Foto e video 360°
            </span>
          )}
        </div>
      )}
      <span className="absolute left-4 top-4 rounded-full bg-white/95 px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-xmove-ink">Usato garantito</span>
      {TIPO_BADGE[auto.tipo_veicolo] && (
        <span className="absolute bottom-4 left-4 flex items-center gap-1.5 rounded-full bg-xmove-night/90 px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-white" data-testid="usato-card-tipo">
          {(() => { const I = TIPO_BADGE[auto.tipo_veicolo].Icon; return <I size={12} />; })()} {TIPO_BADGE[auto.tipo_veicolo].label}
        </span>
      )}
      {auto.neopatentati === "SI" && (
        <span className="absolute right-4 top-4 rounded-full bg-xmove-green px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-white">Neopatentati</span>
      )}
    </div>
    <div className="flex flex-1 flex-col p-5">
      <h3 className="font-display text-lg font-bold leading-tight text-xmove-ink">{auto.marca} {auto.modello}</h3>
      <p className="mt-1 line-clamp-2 text-xs text-xmove-muted">{auto.versione}</p>
      <ul className="mt-4 grid grid-cols-2 gap-x-3 gap-y-1.5 text-xs text-xmove-ink">
        <li className="flex items-center gap-1.5"><CalendarDays size={13} className="text-xmove-orange" /> {auto.anno || "n.d."}</li>
        <li className="flex items-center gap-1.5"><Gauge size={13} className="text-xmove-orange" /> {km(auto.km)}</li>
        <li className="flex items-center gap-1.5"><Fuel size={13} className="text-xmove-orange" /> {auto.alimentazione || "n.d."}</li>
        <li className="flex items-center gap-1.5"><Settings2 size={13} className="text-xmove-orange" /> {(auto.cambio || "n.d.").split(" ")[0]}</li>
        {cvDi(auto) && <li className="flex items-center gap-1.5" data-testid="usato-card-cv"><Zap size={13} className="text-xmove-orange" /> {cvDi(auto)} CV</li>}
      </ul>
      <div className="mt-auto border-t border-xmove-ink/8 pt-4">
        {auto.prezzo ? (
          <p className="font-display text-2xl font-bold text-xmove-ink" data-testid="usato-cardprice">{eur(auto.prezzo)}</p>
        ) : (
          <p className="text-sm font-bold text-xmove-orange" data-testid="usato-cardprice-su-richiesta">Prezzo su richiesta</p>
        )}
        {auto.prezzo ? (
          <p className="text-[11px] text-xmove-muted">chiavi in mano, IVA esposta</p>
        ) : (
          <button type="button" onClick={(e) => contatta(e, auto)} data-testid="usato-card-contattaci" className="text-[11px] font-semibold text-xmove-muted underline decoration-xmove-orange/60 underline-offset-2 transition-colors hover:text-xmove-orange">
            contattaci per avere info →
          </button>
        )}
      </div>
    </div>
  </Link>
);
